import { mapActions } from "vuex";
import { PropertyChangeCommand, SizePropertyChangeCommand } from "../../../commands/PropertyChangeCommand";
import { SectionRearrangeCommand } from "../../../commands/SectionRearrangeCommand";
import { ConvrrtFirebase } from "../../../convrrt-firebase";
import moveElementInArray from "../../../lib/moveElementInArray";
import * as actions from '../../../store/modules/actions';

export default {
  props: {
    fbNode: {
      type: Object,
      default: () => {}
    },
    background: {
      type: Object,
      default () { return {
        coloroverlay: "",
        coloralpha: 1,
        overlay: false
      } }
    },
    padding: {
      type: Object,
      default () { return {} }
    },
    margin: {
      type: Object,
      default () { return {} }
    },
  },
  computed: {
    isEmpty () {
      return this.fbNode && this.fbNode.children
          ? this.fbNode.children.length === 0 : true
    },
  },
  methods: {
    ...mapActions({
      pushCommand: actions.HISTORY_COMMAND_PUSH,
    }),
    firebaseRef () {
      return new ConvrrtFirebase(this.path())
    },
    path () {
      if (this['.path'] === undefined && Object.prototype.hasOwnProperty.call(this.fbNode.data.props, '.path')) {
        return this.fbNode.data.props['.path']
      }
      return this['.path']
    },
    idx() {
      return this.firebaseRef().key
    },
    self () {
      return this.firebaseRef().ref
    },
    moveChild (idx, direction) {
      return this.transaction((children) => {
        return moveElementInArray(children, idx, direction)
      })
    },

    moveUp (steps = -1) {
      let command = new SectionRearrangeCommand(this.$parent, this.idx(), steps)
      this.validateAndPushCommand(command)
    },

    moveDown (steps = 1) {
      let command = new SectionRearrangeCommand(this.$parent, this.idx(), steps)
      this.validateAndPushCommand(command)
    },
    createCommand (key, value) {
      let command = null
      if (['desktop', 'phone'].includes(key)){
        command = new SizePropertyChangeCommand(this, `data/props/${key}`, value)
      }
      else {
        command = new PropertyChangeCommand(this, `data/props/${key}`, value)
      }
      return command
    },
    updateProp: function (key, value) {
      let command = this.createCommand(key, value)
      return this.validateAndPushCommand(command)
    },
    validateAndPushCommand(command) {
      if (command.hasChanges) {
        return this.pushCommand(command)
      }
      return new Promise(resolve => {resolve()})
    },
    deleteNode(idx) {
      this.firebaseRef().removeNode(idx)
    },
  }
}